// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3gBwI","label":"Category_label__18Bgc","content":"Category_content__2oFW_","header":"Category_header__R9YwS","location":"Category_location__2tB5u"};